import Link from "next/link"
import Image from "next/image"
import styled from "styled-components"

function contentSection(key: any, section: any) {
  return (
    <div className="home-content" key={key}>
      {section.title_h2 && <h2>{section.title_h2}</h2>}
      {section.description && <p>{section.description}</p>}
      {section.call_to_action.title && section.call_to_action.href &&
        <Link href={section.call_to_action.href}>
          <a className="btn secondary-btn">{section.call_to_action.title}</a>
        </Link>}
    </div>
  );
}

function imageContent(key: any, section: any) {
  return <Image src={section.image.url} alt={section.image.filename} key={key} width={540} height={402} />
}

const Section = ({ section }: any) =>
  <Container>
    {section.image_alignment === "Left"
      ? [imageContent("key-image", section), contentSection("key-contentstection", section)]
      : [contentSection("key-contentstection", section), imageContent("key-image", section)]}
  </Container>

export default Section

const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  text-align: center;
  margin: 80px 63px 63px 63px;
  flex-wrap: nowrap;
  img {
    max-width: 100%;
    margin-top: 40px;
    filter: grayscale(1);
  }
`